import React from 'react';
import classnames from 'classnames/bind';

import { useStreams } from 'streams/hooks/useStreams';

import { CameraFileListTable } from './Table';

import styles from './FileList.module.scss';

const c = classnames.bind(styles);

export type FileListProps = {
  cameraID: string;
};

export function FileList({ cameraID }: FileListProps) {
  const [page, setPage] = React.useState(1);

  const queryResult = useStreams({
    params: {
      stream_types: ['file'],
      camera_ids: cameraID ? [cameraID] : undefined,
      page,
    },
    enabled: Boolean(cameraID),
    keepPreviousData: true,
  });

  return (
    <div className={c('wrap')}>
      <CameraFileListTable
        queryResult={queryResult}
        pageSize={50}
        page={page}
        onPageChange={setPage}
      />
    </div>
  );
}
